import { HttpClient } from "../../../core/request";

export const getOrderDetails = (order_uuid) => {
  return (dispatch, getState) => {
      return HttpClient(true).get(`orders/uuid/${order_uuid}`)
  }
};


// WEBPACK FOOTER //
// ./src/routes/SuccessPayment/modules/orders.js